export {
  default,
  default as useUpdateWorkDeskPreference,
} from "./useUpdateWorkDeskPreference";
